import * as React from "react";

function SvgNudgespot(props, ref) {
  return (
    <svg
      viewBox="0 0 51 51"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width="1em"
      height="1em"
      {...{ ...props, ref }}
    >
      <defs>
        <path
          id="Nudgespot_svg__a"
          d="M6.884 40.575C2.772 38.138.014 33.604.014 28.412V14.125C.015 6.363 6.205.059 13.84.059h20.708c7.651 0 13.825 6.297 13.825 14.066v14.287c0 7.762-6.19 14.067-13.825 14.067H20.3a4069.426 4069.426 0 01-7.006 5.18c-5.67 4.18-6.41-1.871-6.41-1.871v-5.213z"
        />
      </defs>
      <g fill="none" fillRule="evenodd">
        <g transform="translate(.153 .076)">
          <mask id="Nudgespot_svg__b" fill="#fff">
            <use xlinkHref="#Nudgespot_svg__a" />
          </mask>
          <use fill="#7768AE" xlinkHref="#Nudgespot_svg__a" />
          <path
            d="M-33.42 68.66c-8.085 5.654 79.664 11.596 79.664 11.596S64.784 24.84 65.986 22.97c1.176-1.869-5.789-33.792-5.789-33.792S-25.553 63.02-33.42 68.66z"
            fill="#57BD91"
            mask="url(#Nudgespot_svg__b)"
          />
          <path
            d="M55.835 35.866S-54.856 11.55-60.885 11.76c-6.03.21 36.144 74.741 36.144 74.741s65.098-16.834 67.209-16.908c2.11-.073 13.367-33.728 13.367-33.728z"
            stroke="#FFF"
            strokeWidth={2}
            fill="#F1C057"
            mask="url(#Nudgespot_svg__b)"
          />
          <path
            d="M30.33-52.227S-44.635-17.893-59.285-10.39c-.892.456-1.891 18.73-2.181 18.94-5.064 3.68 58.587 35.584 58.587 35.584S60.225-.751 61.997-2.039C63.77-3.327 30.33-52.227 30.33-52.227z"
            stroke="#FFF"
            strokeWidth={2}
            fill="#625591"
            mask="url(#Nudgespot_svg__b)"
          />
        </g>
      </g>
    </svg>
  );
}

export default React.forwardRef(SvgNudgespot);
